import {
  ALCOHOL_FEMALE,
  ALCOHOL_NOT_FEMALE,
  PARENTS_CONDITIONS
} from "config/tags";

export const sequenceRouting = ({
  nextUrlPath: nextUrlPathInit,
  question,
  assessment,
  routes,
  profile
}) => {
  let nextUrlPath = nextUrlPathInit;

  // Male / female routing for alcohol.
  if (question.tags.includes(PARENTS_CONDITIONS)) {
    nextUrlPath = routes.question(
      assessment.questions.find(q =>
        q.tags.includes(
          profile.gender === "F" ? ALCOHOL_FEMALE : ALCOHOL_NOT_FEMALE
        )
      ).urlPath
    );
  }

  return nextUrlPath;
};
